import styles from './styles.module.css';
import {ComponentWithChildrenProps} from '@interfaces/component';
export default function DropDown(props: ComponentWithChildrenProps) {
  const {children} = props;
  return <div className={styles.dropDown}>{children}</div>;
}
